import React, { FC } from 'react';
import styled from 'styled-components';

import BasicText from '@ui/atoms/BasicText';
import FlexColumn, { IFlexColumn } from '@ui/atoms/FlexColumn';
import SubheadingText from '@ui/atoms/SubheadingText';
import TextLink from '@ui/atoms/TextLink';
import WYSIWYGContent from '@ui/atoms/WYSIWYGContent';

import CardCtaWithBackground from '@ui/molecules/CardCtaWithBackground';

import aligned from '@ui/styled/Aligned';

import { IPageProps } from '@folx-types/flow-steps';

import theme from '@theme/FolxTheme';

export interface ILabsPlaceholderPageContent {
	pageHeader: string;
	pageInfo: string;
	labsCardTitle: string;
	labsCardCtaText: string;
	labsCardCtaLink: string;
	labsCardImage: string;
	pageDisclaimer: string;
}

interface ILabsPlaceholderProps extends IPageProps {
	pageContent: ILabsPlaceholderPageContent;
}

const FullHeightAlignedColumn = styled(aligned<IFlexColumn>(FlexColumn))`
	height: 100%;
`;

const HalfWidthSubheader = styled(SubheadingText)`
	width: ${theme.spacing.half};
	text-shadow: ${theme.shadow.msspBox};
`;

const LabsPlaceholder: FC<ILabsPlaceholderProps> = ({ pageContent }) => {
	const {
		pageHeader,
		pageInfo,
		pageDisclaimer,
		labsCardTitle,
		labsCardCtaText,
		labsCardCtaLink,
		labsCardImage,
	} = pageContent;

	return (
		<FlexColumn gap="lg">
			<FlexColumn gap="md">
				<SubheadingText fontSize="lg" largeFontSize="xl">
					{pageHeader}
				</SubheadingText>
				<BasicText>{pageInfo}</BasicText>
			</FlexColumn>
			<CardCtaWithBackground background={labsCardImage} href={labsCardCtaLink}>
				<FullHeightAlignedColumn gap="smmd" justifyContent="center">
					<HalfWidthSubheader color="white" fontSize="xl" largeFontSize="xxl">
						{labsCardTitle}
					</HalfWidthSubheader>
					<TextLink colorVariant="light" label={labsCardCtaText} href={labsCardCtaLink} newTab />
				</FullHeightAlignedColumn>
			</CardCtaWithBackground>
			<WYSIWYGContent
				linkUnderline
				linkFontWeight="normal"
				textVariant="smallText"
				dangerouslySetInnerHTML={{ __html: pageDisclaimer }}
			/>
		</FlexColumn>
	);
};

export default LabsPlaceholder;
